<template>
  <header class="bg-white border-b border-gray">
    <nav class="container w-full pt-10 px-20 lg:px-50 xl:px-20 h-full flex gap-5 items-center">
      <div class="flex justify-center h-fit">
        <a href="/">
          <img src="../../../../assets/images/drybrush-logo.webp" class="w-140" />
        </a>
      </div>
      <div class="lg:mr-36 xl:mr-0 w-full">
        <search-form class="ml-auto leading-none px-14" placeholder="Search by artwork name or artist name"
          @toggled="redirect" :default-value.sync="searchValue"
          inputClass="rounded-full font-sans py-10 text-14 focus:outline-none">
          <template #icon="{ term }">
            <div class="absolute right-0 center-y mr-12 cursor-pointer">
              <div class="px-10 py-8 text-dark-gray bg-white" @click="redirect({ term: term })">
                <i class="far fa-search text-md"></i>
              </div>
            </div>
          </template>
        </search-form>
      </div>

      <div class="flex items-center justify-end gap-6 xl:gap-20 navbar-menu">
        <slot name="icons"></slot>
      </div>
    </nav>
    <div class="flex justify-between container px-20 lg:px-50 xl:px-20 bg-white pt-4 items-center">
      <div class="flex justify-start">
        <ul class="h-full flex gap-10 font-bold">
          <the-nav-bar-desktop-item v-for="item in menuItems" :key="item.id" :item="item"></the-nav-bar-desktop-item>
        </ul>
      </div>
      <div class="flex items-center gap-6">
        <i class="fas fa-phone-alt text-base text-orange"></i>
        <a href="viber://chat?number=639175652917"
          class="underline font-bold link link-accent text-base whitespace-no-wrap">{{ phone }}</a>
      </div>
    </div>
  </header>
</template>
<script>
import TheNavbarSearchResult from "../../Modules/Search/TheNavbarSearchResult.vue";
import TheNavBarDesktopItem from "./TheNavBarDesktopItem.vue";
import SearchForm from "../../Universal/SearchForm.vue";

export default {
  components: {
    TheNavbarSearchResult,
    TheNavBarDesktopItem,
    SearchForm,
  },

  props: {
    menu: Object,
    phone: String,
  },

  data() {
    return {
      searchValue: new URLSearchParams(window.location.search).get("search"),
    }
  },

  computed: {
    menuItems() {
      return this.menu.menuItems.filter((item) => item.enabled)
    },
  },

  created() {
    window.TheNavBarDesktop = this
    this.urlChecker(this.item)
  },

  methods: {
    redirect(search) {
      if (search.term == null || search.term === "") {
        window.location.assign("/artworks");
      }

      if (search.term != null && search.term !== "") {
        window.location.assign(`/artworks?search=${search.term}`)
      }
    },

    clearSearch() {
      this.searchValue = null
    },

    urlChecker(item) {
      if (item.value.endsWith(window.location.pathname)) {
        this.$set(item, 'active', true)
      } else {
        this.$set(item, 'active', false)
      }
    },
  },
};
</script>

<style>
@media screen and (max-width: 1439px) {
  .navbar-menu {
    margin-right: 30px;
  }
}

@media screen and (max-width: 1124px) {
  .navbar-menu {
    margin-right: 20px;
  }
}

@media screen and (max-width: 1024px) {
  .navbar-menu {
    margin-right: 10px;
  }
}

.desktop-navbar-link {
  position: relative;
}

.desktop-navbar-link:hover {
  color: #ff6700;
}

.desktop-navbar-link:after {
  position: absolute;
  width: 100%;
  opacity: 0%;
  left: 0px;
  bottom: -7px;
  height: 3px;
  transform: translateY(-5px);
  background-color: #ff6700;
}

.desktop-navbar-link:hover:after {
  opacity: 100%;
  content: "";
  transform: translateY(-5px);
}

.active {
  color: #ff6700;
}

.active:after {
  position: absolute;
  width: 100%;
  opacity: 100%;
  content: "";
  left: 0px;
  bottom: -7px;
  height: 3px;
  transform: translateY(-5px);
  background-color: #ff6700;
}
</style>
